import clsx from 'clsx';
import React, { useEffect, useState } from 'react';

import LazyImgixImage from '@components/LazyImgixImage';
import Video from '@components/pages/PageTemplates/Blocks/VideoBlock/Video';
import { Env } from '@contexts/AppContext';
import useServerSideRendering from '@hooks/useServerSideRendering';
import { getArticleImgSrc } from '@utils/images';
import { getFileTypeFromUrl } from '@utils/types';

interface ArticleAssetProps {
  title: string;
  id: number;
  picture: string;
  env: Env;
  isFeaturedArticle?: boolean;
  skipOptimization?: boolean;
  sizes?: string;
  className?: string;
  wrapperClassName?: string;
  posterPicture?: string;
}

const ArticleAsset = ({
  title,
  id,
  picture,
  env,
  isFeaturedArticle = false,
  skipOptimization = false,
  sizes,
  className,
  wrapperClassName,
  posterPicture,
}: ArticleAssetProps) => {
  const [articleAssetType, setArticleAssetType] = useState<string>(null);
  const hydrated = useServerSideRendering();

  useEffect(() => {
    if (!hydrated) return;
    setArticleAssetType(getFileTypeFromUrl(getArticleImgSrc(id, picture, env)));
  }, [hydrated, picture, id, env]);

  return (
    <>
      {articleAssetType === 'video' && (
        <div className={wrapperClassName}>
          <Video
            config={{
              autoplay: true,
              controls: false,
              playsinline: true,
              poster: getArticleImgSrc(id, posterPicture || picture, env),
              muted: true,
              loop: true,
              disablePictureInPicture: true,
              disableRemotePlayback: true,
              css_classes: '!mt-0',
            }}
            content={{ src: getArticleImgSrc(id, picture, env) }}
            maxWidth={clsx('aspect-[16/9] h-auto w-full object-cover', className)}
          />
        </div>
      )}
      {articleAssetType === 'image' &&
        (isFeaturedArticle ? (
          <LazyImgixImage
            alt={title}
            className={clsx('article-hero-image h-auto w-full', className)}
            src={getArticleImgSrc(id, picture, env)}
            sizes={sizes}
            wrapperClassName={clsx('h-full w-full', wrapperClassName)}
            visibleByDefault
          />
        ) : (
          <LazyImgixImage
            alt={title}
            className={clsx('article-image aspect-[16/9] h-auto w-full object-cover', className)}
            src={getArticleImgSrc(id, picture, env)}
            skipOptimization={skipOptimization}
            sizes={sizes}
            wrapperClassName={clsx('!flex', wrapperClassName)}
          />
        ))}
    </>
  );
};

export default ArticleAsset;
